
const config = {
    urls: {
        gitHubJobs: 'https://thingproxy.freeboard.io/fetch/https://jobs.github.com/positions.json',
        gitHubJob: 'https://thingproxy.freeboard.io/fetch/https://jobs.github.com/positions/',
        // gitHubJobs: 'https://cors-anywhere.herokuapp.com/https://jobs.github.com/positions.json',
        // randomProgrammingQuote: 'http://quotes.stormconsultancy.co.uk/random.json',
        randomProgrammingQuote: 'https://favqs.com/api/qotd',
    }
}

export default config;